export default __webpack_public_path__ + "static/media/solo.a078b683.png";